// eslint-disable-next-line no-restricted-imports
import type {
  NotificationGroupModel,
  NotificationModel,
} from 'app/gamma/src/types/models';

// eslint-disable-next-line no-restricted-imports
import type {
  NotificationGroupResponse,
  NotificationGroupsResponse,
  NotificationResponse,
} from 'app/gamma/src/types/responses';
import { normalizeActionData } from './action';

import { normalizeAppCreator } from './app-creator';
import { normalizeBoard } from './board';
import { normalizeCard } from './card';
import { normalizeMember } from './member';

import genericNormalizer, { normalizeDate } from './generic';

export const normalizeNotification = (
  response: NotificationResponse,
  existing?: NotificationModel,
) => {
  return genericNormalizer<NotificationResponse, NotificationModel>(
    ({ from, has }) => ({
      appCreator: has('appCreator', (app) =>
        app ? normalizeAppCreator(app) : undefined,
      ),
      data: has('data', (data) => (data ? normalizeActionData(data) : {})),
      date: has('date', normalizeDate),
      display: from('display'),
      id: from('id'),
      idAction: from('idAction'),
      memberCreator: has('memberCreator', (member) =>
        member ? normalizeMember(member, existing?.memberCreator) : undefined,
      ),
      idMemberCreator: from('idMemberCreator'),
      type: from('type'),
      unread: from('unread'),
      dateRead: from('dateRead'),
      isReactable: from('isReactable'),
    }),
  )(response, existing);
};

export const normalizeNotifications = (
  notifications: NotificationResponse[],
): NotificationModel[] => {
  return notifications.map((notification) =>
    normalizeNotification(notification),
  );
};

// eslint-disable-next-line @trello/no-module-logic
export const normalizeNotificationGroup = genericNormalizer<
  NotificationGroupResponse,
  NotificationGroupModel
>(({ from, has, map }) => ({
  id: has('id', (id) => id.substring(id.indexOf(':') + 1)),
  idGroup: from('id'),
  notifications: map('notifications', normalizeNotification),
  card: has('card', normalizeCard),
  board: has('card', (card) =>
    card.board ? normalizeBoard(card.board) : undefined,
  ),
}));

export const normalizeNotificationGroups = (
  notificationGroups: NotificationGroupsResponse,
): NotificationGroupModel[] => {
  return notificationGroups.map((notificationGroup) =>
    normalizeNotificationGroup(notificationGroup),
  );
};
